/* File for custom javascript */

(function () {

  // Wrap logic in DOM ready event listener
  document.addEventListener("DOMContentLoaded", function () {
    try {
      // Get product info
      const getProductInfo = async (payload) => {
        try {
          const queryString = new URLSearchParams(payload).toString();

          const res = await fetch(`https://xgju0w2fb2.execute-api.us-east-1.amazonaws.com/default/get?${queryString}`, {
            method: 'GET',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json'
            },
            crossDomain: true,
          });
          const data = await res.json();

          if (!data && payload.event === 'search') {
            hideElement($('.manualsList.search-result'));
            showElement($('#supportSearchNotFound'));
          }

          if ($.isArray(data)) {
            localStorage.setItem('supportFilterProducts', JSON.stringify(data));
            localStorage.setItem('supportFilterPage', 1)
            for (i = 1; i < 6; i++) {
              showElement($(`#product-container--${i}`));
            }

            let products = new Array();

            for (i = 0; i < 5; i++) {
              if (i > JSON.parse(localStorage.getItem('supportFilterProducts')).length) {
                continue;
              } else {
                products[i] = JSON.parse(localStorage.getItem('supportFilterProducts'))[i];
              }
            }

            products.forEach((productData, idx) => {
              renderProductFields(productData, payload.event, idx + 1)
            });

          } else {
            renderProductFields(data, payload.event);
          }

          hideElement($('#searchLoader, #categoryLoader'));
          return data.length;

        } catch (error) {
          console.error(error);
        }
      }

      const showElement = (el) => {
        el.removeClass('titan-hide');
      };

      const hideElement = (el) => {
        el.addClass('titan-hide');
      };

      const manualLabelTranslations = {
        "Documentation": "Documentation",
        "Owner's Manual": "Manuel du propriétaire",
        "Owner's Manual French": "Manuel du propriétaire en français",
        "Product Warranty": "Garantie du produit",
        "Quick Start Guide": "Guide de démarrage rapide"
      };

      const renderManuals = (manuals, containerID) => {
        const parsed = JSON.parse(manuals.value);
        const values = Object.keys(parsed);
        const language = document.location.href.includes('soutien') ? 'fr' : 'en';

        values.forEach((key, i) => {
          let ids = getIds(containerID, i);

          if ($.isArray(parsed[key])) {
            parsed[key].forEach((val, i) => {
              $(`${containerID} ${ids.manual} a`).text(key);
              $(`${containerID} ${ids.manual} a`).attr('href', val);
              showElement($(`${containerID} ${ids.manual}`));
            });
          }
          else {
            if (language === 'en') {
              $(`${containerID} ${ids.manual} a`).text(key);
            } else {
              $(`${containerID} ${ids.manual} a`).text(manualLabelTranslations[key]);
            }
            $(`${containerID} ${ids.manual} a`).attr('href', parsed[key]);
            showElement($(`${containerID} ${ids.manual}`));
          }
        });

        if (values.length < $(`${containerID} .manualsList-list:not('.firmware-list') a`).length) {
          for (i = values.length; i < $(`${containerID} .manualsList-list:not('.firmware-list') a`).length; i++) {
            emptyEl = $(`${containerID} .manualsList-list:not('.firmware-list') a`)[i];
            emptyElParent = $(`${containerID} .manualsList-list:not('.firmware-list') li`)[i];
            $(emptyEl).text() === '' ? hideElement($(emptyElParent)) : null;
          }
        }
      }

      const transformMultiMetafield = (firmwareListing) => {
        firmwareListing = firmwareListing.value.split('\n');
        let firmware = {};
        let firmwareList = [];

        for (let i = 0; i < firmwareListing.length; i++) {
          if (firmwareListing[i].split('~')[0].trim() === 'Firmware Name') {
            if (firmware['Firmware Name']) {
              firmware = {};
            }

            firmware['Firmware Name'] = firmwareListing[i].split('~')[1].trim();
          } else if (firmwareListing[i].split('~')[0].trim() === 'Firmware Description') {
            firmware['Firmware Description'] = firmwareListing[i].split('~')[1].trim();
          } else if (firmwareListing[i].split('~')[0].trim() === 'Firmware Release Date') {
            firmware['Firmware Release Date'] = firmwareListing[i].split('~')[1].trim();
          } else if (firmwareListing[i].split('~')[0].trim() === 'Firmware Version') {
            firmware['Firmware Version'] = firmwareListing[i].split('~')[1].trim();
          } else if (firmwareListing[i].split('~')[0].trim() === 'Firmware Instructions') {
            firmware['Firmware Instructions'] = firmwareListing[i].split('~')[1].trim();
          } else if (firmwareListing[i].split('~')[0].trim() === 'Firmware Letter') {
            firmware['Firmware Letter'] = firmwareListing[i].split('~')[1].trim();
          } else if (firmwareListing[i].split('~')[0].trim() === 'Firmware file') {
            firmware['Firmware file'] = firmwareListing[i].split('~')[1].trim();
            firmwareList.push(firmware);
          } else if (firmwareListing[i].split('~')[0].trim() === 'Firmware Instructions French') {
            firmware['Firmware Instructions French'] = firmwareListing[i].split('~')[1].trim();
          } else if (firmwareListing[i].split('~')[0].trim() === 'Firmware Letter French') {
            firmware['Firmware Letter French'] = firmwareListing[i].split('~')[1].trim();
          } else {
            console.warn('hit else in transformMultiMetafield()');
          }
        }
        return firmwareList;
      }

      const getIds = (idSelector, i) => {
        if (idSelector.indexOf('search') >= 0) {
          containerID = `#firmware-container-search-result-${i + 1}`;
          subTitleID = `#search-subtitle-${i + 1}`;
          listID = `#search-firmware-list-${i + 1}`;
          manualListID = `#manual-search-list-${i + 1}`;
          manualID = `#manual-search-item-${i + 1}`
        } else {
          containerID = `#firmware-container--${i + 1}`;
          subTitleID = `#subtitle-${i + 1}`;
          listID = `#firmware-list-${i + 1}`;
          manualListID = `#manual--list-${i + 1}`;
          manualID = `#manual--item-${i + 1}`
        }

        return { container: containerID, subTitle: subTitleID, list: listID, manualList: manualListID, manual: manualID };
      }

      const renderFirmware = (firmwareListing, idSelector) => {
        const parsed = firmwareListing.key === 'firmware' ?
          JSON.parse(firmwareListing.value) :
          transformMultiMetafield(firmwareListing);

        //Product has multiple firmware to be shown
        if ($.isArray(parsed)) {
          parsed.forEach((firmware, i) => {

            try {
              if (firmware.hasOwnProperty('Firmware Name')) {
                let ids = getIds(idSelector, i);

                firmware['Firmware Name'].length && $(`${idSelector} ${ids.container} ${ids.subTitle} a`).text(firmware['Firmware Name']);

                firmware['Firmware file'].length && $(`${idSelector} ${ids.container} ${ids.subTitle} a`).attr('data-href', firmware['Firmware file']);

                firmware['Firmware file'].length && $(`${idSelector} ${ids.container} ${ids.subTitle} a`).attr('data-type', 'firmware');

                firmware['Firmware Name'].length && firmware['Firmware file'].length ?
                  showElement($(`${idSelector} ${ids.container} ${ids.subTitle}, ${idSelector} ${ids.container} ${ids.subTitle} a`)) :
                  hideElement($(`${idSelector} ${ids.container} ${ids.subTitle}, ${idSelector} ${ids.container} ${ids.subTitle} a`));

                firmware['Firmware Instructions'].length && $(`${idSelector} ${ids.container} ${ids.list} .firmware-instructions a`).attr('href', firmware['Firmware Instructions']);
                firmware['Firmware Instructions French']?.length && $(`${idSelector} ${ids.container} ${ids.list} .firmware-instructions-french a`).attr('href', firmware['Firmware Instructions French']);

                firmware['Firmware Instructions'].length ?
                  showElement($(`${idSelector} ${ids.container} ${ids.list} .firmware-instructions`)) :
                  hideElement($(`${idSelector} ${ids.container} ${ids.list} .firmware-instructions`));

                firmware['Firmware Instructions French']?.length ?
                  showElement($(`${idSelector} ${ids.container} ${ids.list} .firmware-instructions-french`)) :
                  hideElement($(`${idSelector} ${ids.container} ${ids.list} .firmware-instructions-french`));

                firmware['Firmware Letter'].length && $(`${idSelector} ${ids.container} ${ids.list} .firmware-notice a`).attr('href', firmware['Firmware Letter']);
                firmware['Firmware Letter French']?.length && $(`${idSelector} ${ids.container} ${ids.list} .firmware-notice-french a`).attr('href', firmware['Firmware Letter French']);

                firmware['Firmware Letter']?.length ?
                  showElement($(`${idSelector} ${ids.container} ${ids.list} .firmware-notice`)) :
                  hideElement($(`${idSelector} ${ids.container} ${ids.list} .firmware-notice`));

                firmware['Firmware Letter French']?.length ?
                  showElement($(`${idSelector} ${ids.container} ${ids.list} .firmware-notice-french`)) :
                  hideElement($(`${idSelector} ${ids.container} ${ids.list} .firmware-notice-french`));

                showElement($(`${idSelector} ${ids.container}`));

                // if the firmware is the last in the list, hide any remaining containers
                const firmwareCount = parsed.length;
                const visibleFirmwareFields = $(`${idSelector} *[id*=firmware-container]:not('.titan-hide')`).length;

                if (firmwareCount < visibleFirmwareFields) {
                  for (let i = firmwareCount + 1; i <= visibleFirmwareFields; i++) {
                    hideElement($(`${idSelector} #firmware-container--${i}, ${idSelector} #firmware-container-search-result-${i}`));
                  }
                }

                if ($(`${idSelector} ${ids.container} ${ids.list} .firmware-notice`).length > 1) {
                  $(`${idSelector} ${ids.container} ${ids.list} .firmware-notice`).first().nextAll().remove();
                }
              }
              else if (firmwareListing.key === 'firmware_multi_line') {
                ids = getIds(idSelector, 0);
                hideElement($(`${idSelector} ${ids.container} ${ids.subTitle} a`));
                showElement($(`${idSelector} ${ids.container} ${ids.subTitle},
                             ${idSelector} ${ids.container} .firmware-instructions,
                             ${idSelector} ${ids.container} .firmware-notice`));

                //get total number of firmware from the array which contains 1 text string and 1 url per firmware.
                const firmwareNum = firmwareListing.value.split(', ').length / 2;

                if (i > 1) {
                  itemClone = $(`${idSelector} ${ids.list} li:nth-child(2)`).first().clone();
                  $(`${idSelector} ${ids.list}`).append(itemClone);
                }

                $(`${idSelector} ${ids.container} ${ids.list} li:nth-child(${i + 1}) a`).text(firmware.name);
                $(`${idSelector} ${ids.container} ${ids.list} li:nth-child(${i + 1}) a`).attr({ 'data-href': firmware.firmware_url, 'href': firmware.firmware_url });

                const visibleFirmwareFields = $(`${idSelector} *[id*=firmware-container]:not('.titan-hide')`).length;

                if (visibleFirmwareFields > 1) {
                  for (let i = 2; i <= visibleFirmwareFields; i++) {
                    hideElement($(`${idSelector} #firmware-container--${i}, ${idSelector} #firmware-container-search-result-${i}`));
                  }
                }
              }
              else {
                ids = getIds(idSelector, 0);
                $(`${idSelector} ${ids.container} ${ids.subTitle} a`).text(firmware.name);
                $(`${idSelector} ${ids.container} ${ids.subTitle} a`).attr('data-href', firmware.firmware_url);

                showElement($(`${idSelector} ${ids.container} ${ids.subTitle}, ${idSelector} ${ids.container} ${ids.subTitle} a`));

                if (firmware.instructions?.length) {
                  $(`${idSelector} ${ids.container} ${ids.list} .firmware-instructions a`).attr('href', firmware.instructions).text('Update Instructions');
                  showElement($(`${idSelector} ${ids.container} ${ids.list} .firmware-instructions, ${idSelector} ${ids.container} ${ids.list} .firmware-instructions a`));
                } else {
                  hideElement($(`${idSelector} ${ids.container} ${ids.list} .firmware-instructions`));
                }

                if (firmware.notice?.length) {
                  $(`${idSelector} ${ids.container} ${ids.list} .firmware-notice a`).attr('href', firmware.notice).text('Update Notice Letter');
                  showElement($(`${idSelector} ${ids.container} ${ids.list} .firmware-notice, ${idSelector} ${ids.container} ${ids.list} .firmware-notice a`));

                  const firmwareFields = $(`${idSelector} *[id*=firmware-container]:not('.titan-hide') .firmware-notice`).length

                  firmwareFields > 2 ? $(`${ids.list} .firmware-notice`).first().nextAll().remove() : null;
                }
                else {
                  hideElement($(`${idSelector} ${ids.container} ${ids.list} .firmware-notice`));
                }
              }
            } catch (err) {
              console.error('error caught in renderFirmware(), err: ', err);
            }
          });
        }
        else {
          ids = getIds(idSelector, 0);

          if (parsed['Firmware Name']) {
            parsed['Firmware Name'].length && $(`${idSelector} ${ids.container} ${ids.subTitle} a`).text(parsed['Firmware Name']);

            parsed['Firmware File'].length && $(`${idSelector} ${ids.container} ${ids.subTitle} a`).attr('data-href', parsed['Firmware File']);

            parsed['Firmware Instructions'].length && $(`${idSelector} ${ids.container} ${ids.list} .firmware-instructions a`).attr('href', parsed['Firmware Instructions']);

            parsed['Firmware Letter'].length && $(`${idSelector} ${ids.container} ${ids.list} .firmware-notice a`).attr('href', parsed['Firmware Letter']);

            showElement($(`${idSelector} ${ids.container} ${ids.subTitle}, ${idSelector} ${ids.container} ${ids.subTitle} a, ${idSelector} ${ids.container} ${ids.list}`));
          }
          else {
            hideElement($('.manualsList-item:first-child .firmware-title, .manualsList-item:first-child .firmware-title a, .manualsList-item:first-child .firmware-list .firmware-instructions, .manualsList-item:first-child .firmware-list .firmware-notice'));
          }
        }
      };

      function renderProductFields(data, type, idx) {
        let idSelector = null;

        if (data == undefined) {
          hideElement($(`#product-container--${idx}`));
          hideElement($(`#product-container--${idx}`).nextAll());
          return;
        }

        if (idx != null) {
          idSelector = `#product-container--${idx}`;
        } else {
          idSelector = `#product-container-search-result-1`;
        }

        if (data?.product?.hasOwnProperty('id')) {
          // Hide no results element
          $('#supportSearchNotFound').hasClass('titan-hide') == true ? null : hideElement($('#supportSearchNotFound'));

          // Display support product cards
          showElement($(`${idSelector}`));

          // Add image to product card
          if (data.product.image?.src) {
            $(`${idSelector} .manualsList-media img`).attr('src', data.product.image.src);
            showElement($(`${idSelector} .manualsList-media img`));
          } else {
            hideElement($(`${idSelector} .manualsList-media img`));
          }


          // Add title to product card
          $(`${idSelector} .manualsList-title`).text(data.product.title);

          const manualsMetafield = data.metafields.find((metafield) => {
            return metafield.key === 'manuals';
          });

          const firmwareMetafield = data.metafields.find((metafield) => {
            return metafield.key === 'firmware_multi'
          });

          const firmwareMultiMetafield = data.metafields.find((metafield) => {
            return metafield.key === 'firmware_multi_line'
          });

          manualsMetafield ? renderManuals(manualsMetafield, idSelector) : hideElements($('.manualsList-item:first-child .manualsList-subtitle:not(.firmware-title), .manualsList-item:first-child .manuals-list:not(.firmware-list), .manualsList-item:first-child .manualsList-item .manualsList-list-manual'));

          if (firmwareMetafield) {
            renderFirmware(firmwareMetafield, idSelector);
          } else
            if (firmwareMultiMetafield) {
              renderFirmware(firmwareMultiMetafield, idSelector);
            } else {
              hideElement($(`
              ${idSelector} .firmware-title, 
              ${idSelector} .firmware-title a, 
              ${idSelector} .firmware-list .firmware-instructions,
              ${idSelector} .firmware-list .firmware-instructions-french, 
              ${idSelector} .firmware-list .firmware-notice,
              ${idSelector} .firmware-list .firmware-notice-french`));
            }
        }
      };

      const resetContainers = () => {
        $('.manualsList').children().toArray().forEach((container) => {
          $(container).find('.manualsList-title').text('');
          $(container).find('.firmware-title a').text('').attr({ 'href': '', 'data-href': '#' });
          $(container).find('.firmware-list li a').attr({ 'href': '', 'data-href': '#' });
          $(container).find('.manualsList-list-manual a').text('').attr({ 'href': '', 'data-href': '#' })
        });
      }

      const buildPagination = (totalProducts) => {
        showElement($('.support-category-pagination'));
        if ($('.yv-pagination-item').length > 2) {
          $('.yv-pagination-item:not(:first, :last)').remove();
        }
        let currentPage = localStorage.getItem('supportFilterPage');

        $('.support-pagination-next').attr({
          'data-page': parseInt(currentPage) + 1
        });

        for (i = 1; i <= Math.ceil(totalProducts / 5); i++) {
          clone = $('.next').clone(true, true);
          $('.support-category-pagination').children('.next').before(clone);
          $('.next').first().removeClass('next').addClass(`${i}`);
          $(`.${i} a`).text(`${i}`).attr({ 'data-page': i });
        }

        $(`.yv-pagination-item.1`).addClass('active');
      }

      // If support search button is present, add event listener on click that handles support search API call and logic
      if ($('.supportSearch-submit').length) {
        $('.supportSearch-submit').on('click', async function (e) {
          e.preventDefault();
          // Show the loader
          showElement($('#searchLoader, .manualsList.search-result'));
          hideElement($('.manualsList:not(".search-result"), .support-category-pagination'));
          resetContainers();
          const searchValue = $('#SupportSearchForm-field').val().trim();

          let payload = {
            event: 'search',
            sku: searchValue,
            shop: window.Shopify.shop,
            language: document.location.href.includes('soutien')? 'fr' : 'en'
          };

          await getProductInfo(payload);
        });
      }

      if ($('.supportSearch-category-filter').length) {
        $('.supportSearch-category-filter').on('click', async (e) => {
          showElement($('#categoryLoader, .manualsList:not(".search-result")'));
          hideElement($('.manualsList.search-result'))
          const collectionID = $(e.target).attr('data-collection-id');

          let payload = {
            event: 'filter',
            collection: collectionID,
            shop: window.Shopify.shop,
            language: document.location.href.includes('soutien') ? 'fr' : 'en'
          };

          let totalProducts = await getProductInfo(payload);
          localStorage.setItem('supportFilterPage', 1);

          if (totalProducts > 5) {
            buildPagination(totalProducts);
          } else {
            hideElement($('.support-category-pagination'));
          }
        });
      }

      if ($('.support-category-pagination').length) {
        $('.yv-pagination-item').on('click', (e) => {
          currentPage = parseInt(localStorage.getItem('supportFilterPage'));
          toPage = $(e.target).is('svg') ? $(e.target).parent().data('page') : $(e.target).data('page');

          if (currentPage == toPage) {
            return;
          } else {

            let offset = 0;

            if (toPage > 1) {
              offset = toPage * 5 - 5;
            }

            let products = new Array(5);

            for (i = offset, j = 0; j < 5; i++, j++) {
              if (i > JSON.parse(localStorage.getItem('supportFilterProducts')).length) {
                continue;
              } else {
                products[j] = JSON.parse(localStorage.getItem('supportFilterProducts'))[i];
              }
            }

            products.forEach((productData, idx) => {
              renderProductFields(productData, 'filter', idx + 1)
            });

            setPaginationState(currentPage, toPage);
          }
        });

        const setPaginationState = (currentPage, toPage) => {
          if (toPage === undefined) {
            return;
          }

          const supportFilterProducts = JSON.parse(localStorage.getItem('supportFilterProducts'));
          const numPages = Math.ceil(supportFilterProducts.length / 5);

          const previousButton = $('.previous');
          const nextButton = $('.next');
          const previousLink = $('.previous a');
          const nextLink = $('.next a');
          const currentPager = $(`.yv-pagination-item.${currentPage}`);
          const newPager = $(`.yv-pagination-item.${toPage}`);

          const prevPage = toPage - 1;
          const nextPage = toPage + 1;

          if (toPage > 1) {
            previousButton.removeClass('disabled');
          } else {
            previousButton.addClass('disabled');
          }

          if (toPage < numPages) {
            nextButton.removeClass('disabled');
          } else {
            nextButton.addClass('disabled');
          }

          previousLink.data('page', prevPage);
          nextLink.data('page', nextPage);
          currentPager.removeClass('active');
          newPager.addClass('active');

          localStorage.setItem('supportFilterPage', toPage);
        }
      }
    } catch (err) {
      console.error('error caught in dom ready in supportSearch.js, err: ', err);
    }
  });
  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
